// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lato_de8755', '__Lato_Fallback_de8755'","fontStyle":"normal"},"className":"__className_de8755","variable":"__variable_de8755"};